import axios from "axios";
import {ENDPOINTS, SITE_SEARCH_API_KEY, SITE_SEARCH_AUTHORITY} from "../../../js/api/_config";

export class TrainingAzureSearchServices {
    static searchForGeneralData(requestBody) {
        return axios({
            method: 'POST',
            url: ENDPOINTS.TRAINING_NEW_SEARCH.TRAINING_SEARCH_URL,
            headers: {
                'api-key': SITE_SEARCH_API_KEY,
                'content-type': "application/json",
                "authority": SITE_SEARCH_AUTHORITY
            },
            data: requestBody
        }).then(e => {
            return e.data;
        }).catch(e => {
            return e.response !== undefined ? "" : "";
        })
    }
}
